module.exports = __webpack_public_path__ + "img/img2.9726e463.png";